<template>
    <table class="text-center font-weight-bold">
        <tr class="grey lighten-3">
            <td rowspan="2" class="reportBorders">Schnitt</td>
            <td rowspan="2" class="reportBorders">Mannschaftsleistung</td>
            <td rowspan="2" class="reportBorders">FW</td>
            <td rowspan="2" class="reportBorders">Differenz</td>
            <td rowspan="2" class="reportBorders">Tab.Pkt</td>
            <td class="reportBorders">SaP</td>
            <td rowspan="2" colspan="3"
                class="reportBorders font-weight-bold text-decoration-underline">
                ENDERGEBNIS</td>
            <td class="reportBorders">SaP</td>
            <td rowspan="2" class="reportBorders">Tab.Pkt</td>
            <td rowspan="2" class="reportBorders">Differenz</td>
            <td rowspan="2" class="reportBorders">FW</td>
            <td rowspan="2" class="reportBorders">Mannschaftsleistung</td>
            <td rowspan="2" class="reportBorders borderRight">Schnitt</td>
        </tr>
        <tr class="grey lighten-3">
            <td class="reportBorders">M-LP</td>
            <td class="reportBorders">M-LP</td>
        </tr>
        <tr v-if="!isLeer">
            <td class="leftCell"
                rowspan="2">{{dataObject.heim.result.schnitt}}</td>
            <td class="leftCell" rowspan="2" style="max-width: 100px">
                {{dataObject.heim.result.kegel}}
                <div class="caption" style="line-height: 1.2;">
                    {{dataObject.getTeamRekordString('heim')}}
                </div>
            </td>
            <td class="leftCell"
                rowspan="2">{{dataObject.heim.result.fw}}</td>
            <td class="leftCell"
                rowspan="2">
                {{dataObject.heim.result.kegel - dataObject.gast.result.kegel}}
            </td>
            <td class="leftCell"
                rowspan="2">{{dataObject.heim.result.tabPkt}}</td>
            <td class="leftCell">
                {{dataObject.heim.result.sp}}</td>
            <td class="leftCell result font-weight-bold"
                rowspan="2">{{dataObject.heim.result.mp}}</td>
            <td class="leftCell" rowspan="2">:</td>
            <td class="leftCell result font-weight-bold"
                rowspan="2">{{dataObject.gast.result.mp}}</td>
            <td class="leftCell">{{dataObject.gast.result.sp}}</td>
            <td class="leftCell" rowspan="2">{{dataObject.gast.result.tabPkt}}</td>
            <td class="leftCell" rowspan="2">
                {{dataObject.gast.result.kegel - dataObject.heim.result.kegel}}
            </td>
            <td class="leftCell" rowspan="2">{{dataObject.gast.result.fw}}</td>
            <td class="leftCell" rowspan="2" style="max-width: 100px">
                {{dataObject.gast.result.kegel}}
                <div class="caption" style="line-height: 1.2;">
                    {{dataObject.getTeamRekordString('gast')}}
                </div>
            </td>
            <td class="leftCell borderRight" rowspan="2">{{dataObject.gast.result.schnitt}}</td>
        </tr>
        <tr v-else>
            <td class="leftCell" rowspan="2"></td>
            <td class="leftCell" rowspan="2" style="max-width: 100px"></td>
            <td class="leftCell" rowspan="2"></td>
            <td class="leftCell" rowspan="2"></td>
            <td class="leftCell" rowspan="2"></td>
            <td class="leftCell"></td>
            <td class="leftCell result font-weight-bold" rowspan="2"></td>
            <td class="leftCell" rowspan="2">:</td>
            <td class="leftCell result font-weight-bold" rowspan="2"></td>
            <td class="leftCell" style="height: 20px"></td>
            <td class="leftCell" rowspan="2"></td>
            <td class="leftCell" rowspan="2"></td>
            <td class="leftCell" rowspan="2"></td>
            <td class="leftCell" rowspan="2" style="max-width: 100px"></td>
            <td class="leftCell borderRight" rowspan="2"></td>
        </tr>
        <tr v-if="!isLeer">
            <td class="secondRowCell">
                {{dataObject.heim.result.mlp}}</td>
            <td class="secondRowCell">
                {{dataObject.gast.result.mlp}}</td>
        </tr>
        <tr v-else>
            <td class="secondRowCell"  style="height: 20px"></td>
            <td class="secondRowCell"></td>
        </tr>
    </table>
</template>

<script>
    export default {
        name: "spiel-bericht-print-result",
        props: ['dataObject', 'isLeer'],
    }
</script>

<style scoped>
    table {width: 100%; border-spacing: 0; table-layout: auto; font-size: 12px}
    .result {font-size: 16px}
    .leftCell {
        border-left: solid 1px grey;
        border-top: solid 1px grey;
        border-bottom: solid 1px grey;
    }
    .secondRowCell {
        border-left: solid 1px grey;
        border-bottom: solid 1px grey;
    }
    .secondRowCellBottom {
        border-bottom: solid 1px grey;
    }
    .reportBorders {
        border-left: solid 1px grey;
        border-top: solid 1px grey;
    }
    .borderRight {border-right: solid 1px grey; }
    /*tr { border-left: solid 1px grey; border-top: solid 1px grey}
    td {border-right: solid 1px grey; border-bottom: solid 1px grey}*/
</style>